import firebase from 'firebase/compat/app';
import 'firebase/compat/auth'
import 'firebase/compat/firestore'

/* Firebase Config */
var config = {
    apiKey: "AIzaSyC-epvW5r7lG-u5l8aBgXigpTzNBSYY344",
    authDomain: "signamed-44de6.firebaseapp.com",
    projectId: "signamed-44de6",
    storageBucket: "signamed-44de6.appspot.com",
    messagingSenderId: "693567836068",
    appId: "1:693567836068:web:dbbec317fb8c98bd5ebb31",
    measurementId: "G-HVWFTCLL73"
};

const app = firebase.initializeApp(config);
// app.setPersistence(firebase.auth.Auth.Persistence.SESSION);
app.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
export const firebase_auth = app.auth();
firebase_auth.languageCode = "es";
export const firebase_db = app.firestore();
export const firestore = firebase.firestore;
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const githubProvider = new firebase.auth.GithubAuthProvider();

export default app